<template>
  <div class="register-header">
    <div class="p-content header-content">
      <img class="header-logo" src="@/assets/imgs/index/logo-onlytext.png">
      <span
        class="header-hello"
      ><span v-show="state !== 2">您好，欢迎注册</span></span>
      <span v-show="state !== 1">
        <span class="header-account">已有账号?</span>
        <router-link to="/login" class="header-login">去登录</router-link>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RegisterHeader',
  props: {
    // 0默认1注册企业2忘记密码
    state: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.register-header {
  padding-top: 32px;
  background-color: white;
}
.header-content {
  height: 83px;
  align-items: center;
  display: flex;
}
.header-logo {
  height: 54px;
}
.header-content span {
  font-size: 18px;
}
.header-hello {
  color: black;
  flex: 1;
  margin-left: 60px;
}
.header-account {
  color: #3d3d3d;
}
.header-login {
  color: #f6713d;
}
</style>
